import React from "react";
import { FiLayers } from "react-icons/fi";
import {
  LuSettings,
  LuUsers,
  LuCircleCheck,
  LuSearch,
  LuSmartphone,
  LuShieldCheck,
  LuPercent,
  LuShield,
  LuBuilding2,
  LuCpu,
  LuClipboardList,
  LuCode,
  LuBug,
  LuRocket,
} from "react-icons/lu";

export const PwaAppHeroData = {
  backgroundImage: "/images/serviceBanners/PWABanner.webp",
  whiteImage: "/images/serviceBanners/PWAB.webp",
  subTitle: "Progressive Web App Development Services",
  title: (
    <>
      App-like PWA <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Experiences in Browser</span>
    </>
  ),
  description:
    "We build high performance Progressive Web Apps that deliver app like experiences directly in the browser with offline support, push notifications, and fast loading for seamless cross device user engagement.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("PWA Quote clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("PWA Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Offline Access",
      desc: "Enable full functionality even without internet connection.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Zero Installation",
      desc: "Instant access directly from browser without app store installation.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Ultra Performance",
      desc: "Fast loading with advanced caching and optimized assets.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Push Engagement",
      desc: "Re-engage users using push notifications for better retention.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

// 2. Stats Block
export const pwaStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Why Choose Us / Solutions Block
export const pwaSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "PWA Solutions for Modern Engagement",
  buildCards: [
    {
      title: "Modern PWA Development",
      desc: "Build native-like progressive web apps that work seamlessly across all devices.",
      icon: LuSmartphone,
      colorClass: "text-[#02d3ee]",
      bgClass: "bg-[#02d3ee]/10",
      borderClass: "border-[#02d3ee]/20 hover:border-[#02d3ee]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(2,211,238,0.25)]",
    },
    {
      title: "PWA Optimization",
      desc: "Upgrade existing web apps to meet modern PWA standards and performance.",
      icon: LuCpu,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Service Worker Integration",
      desc: "Enable offline caching, background sync, and smart network handling.",
      icon: FiLayers,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Enterprise Web Portals",
      desc: "Develop secure and scalable enterprise-grade responsive web platforms.",
      icon: LuBuilding2,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Offline Capability Enhancement",
      desc: "Ensure full functionality even without an active internet connection.",
      icon: LuSmartphone,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "Push Notification System",
      desc: "Implement engagement-driven push notifications for better user retention.",
      icon: FiLayers,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "PWA ENGINEERING STRATEGY",
  processTitle: "PWA Engineering Strategy",
  processSteps: [
    {
      step: "01",
      title: "Audit & Analysis",
      description: "Evaluate existing web structure and identify PWA improvement opportunities.",
      icon: LuSearch,
    },
    {
      step: "02",
      title: "Implementation",
      description: "Configure service workers, caching strategies, and manifest setup.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Testing & Deployment",
      description: "Test across devices, offline states, and deploy optimized PWA build.",
      icon: LuCode,
    },
    {
      step: "04",
      title: "Performance Optimization",
      description: "Improve load speed using caching and resource optimization techniques.",
      icon: LuBug,
    },
    {
      step: "05",
      title: "Service Worker Setup",
      description: "Enable background sync, offline access, and smart caching behavior precisely.",
      icon: LuCircleCheck,
    },
    {
      step: "06",
      title: "Cross-Device Validation",
      description: "Ensure a consistent PWA experience across mobile, tablet, and desktop viewports.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE PROGRESSIVE WEB APPS?",
  benefitsTitle: "Future of Low-Friction Discovery",
  benefits: [
    "Offline usability support",
    "Skip app store delays",
    "Responsive cross-device UI",
    "Lightweight memory usage",
    "Instant UI rendering speed",
    "SEO indexing improvement",
    "Fast content delivery",
  ],
  logoImage: "/images/serviceBanners/PWABanner.webp",
  whiteLogoImage: "/images/serviceBanners/PWAB.webp",
};

// 4. Portfolio / Case Studies Data Block
export const pwaPortfolioData = {
  subtitle: "OUR PROJECTS",
  title: "High Performance PWA Environments",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "DashWeb Terminal",
      badge: "Enterprise PWA",
      badgeColor: "bg-[#02d3ee]/10 text-[#02d3ee] border-[#02d3ee]/20",
      desc: "Full offline execution data screen allowing local file modifications during heavy network dropouts.",
      downloads: "Instant Load",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/PWA_Development.png",
    },
    {
      title: "CoreRetail Portal",
      badge: "E-Commerce App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "Lightweight retail web engine utilizing push reminder modules to boost user action conversion statistics.",
      downloads: "+80% Ret",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/Android-UIUX.png",
    },
  ],
};

// 5. Technologies Data Block
export const pwaTechnologiesData = {
  techTitle: "TECHNOLOGIES WE EMBED",
  technologies: [
    { name: "Next.js", icon: "NextJS" },
    { name: "React", icon: "React" },
    { name: "Service Workers", icon: "Workers" },
    { name: "Workbox", icon: "Workbox" },
    { name: "PWA Manifest", icon: "Manifest" },
    { name: "Firebase", icon: "Firebase" },
  ],
  trustTitle: "TRUSTED BY LEADING TEAMS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Overview Block
export const pwaAboutData = [
  {
    title: "Progressive Web App Development for Faster Digital Experiences",
    content: (
      <>
        Modern businesses need digital products that deliver smooth performance without forcing users to download applications. Reliable{" "}
        <b className="text-text-primary font-semibold">progressive web app development</b> help organizations create app-like experiences that improve accessibility, customer
        engagement, and overall usability. Many businesses struggle with high app abandonment rates and complicated installation processes that reduce conversions. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, PWA solutions are developed around business goals, customer behavior, and performance expectations to
        help brands create seamless digital experiences that support long-term growth.
      </>
    ),
  },
  {
    title: "PWA Development Company for Better User Engagement",
    content: (
      <>
        Creating successful digital experiences requires platforms that remain responsive and accessible across devices. A trusted{" "}
        <b className="text-text-primary font-semibold">pwa development company</b> helps businesses build scalable applications that improve interaction quality and support
        consistent customer experiences. Companies investing in <b className="text-text-primary font-semibold">progressive web application services</b> often benefit from stronger
        engagement because users can access applications more easily without traditional barriers. Tycho Technologies focuses on practical PWA frameworks designed to improve
        usability while supporting long-term digital flexibility and business efficiency.
      </>
    ),
  },
  {
    title: "Mobile Web App Development for Scalable Growth",
    content: (
      <>
        Businesses aiming to improve digital accessibility often prioritize technologies that work smoothly across mobile, tablet, and desktop environments. Reliable{" "}
        <b className="text-text-primary font-semibold">mobile web app development</b> helps organizations create responsive experiences that improve customer retention and digital
        performance. Companies looking to strengthen mobile ecosystems frequently align digital strategies with{" "}
        <a href="https://tychotechnologies.com/flutter-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          flutter app development company
        </a>{" "}
        solutions to improve scalability and support broader customer accessibility.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a PWA Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">pwa development company in india</b> continues to grow as businesses seek cost-effective and
        scalable web application frameworks. Companies investing in <b className="text-text-primary font-semibold">progressive web app development india</b> often focus on
        usability, accessibility, and stronger customer experiences across devices. Businesses partnering with Tycho Technologies gain access to customized PWA strategies designed
        around measurable business objectives and user expectations. Many organizations also strengthen digital ecosystems through{" "}
        <a href="https://tychotechnologies.com/react-native-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          react native app development company
        </a>{" "}
        solutions to support connected and future-ready mobile experiences.
      </>
    ),
  },
];

// 7. Core FAQs
export const pwaFaqs = [
  {
    q: "Why should I hire PWA developers in India?",
    a: "Hiring PWA (Progressive Web App) developers in India gives you access to skilled professionals at a cost-effective price. Indian developers can create fast, responsive, and offline-capable PWAs that work seamlessly across devices while following global standards.",
  },
  {
    q: "What do PWA developers do?",
    a: "PWA developers design and build Progressive Web Apps that combine the best of web and mobile apps. They focus on speed, offline functionality, push notifications, and smooth user experiences, helping businesses reach users without requiring app store downloads.",
  },
  {
    q: "What makes a PWA developer the best?",
    a: "The best PWA developers have strong technical skills, experience in modern web technologies, and a focus on creating fast, reliable, and engaging apps. They also ensure excellent UI/UX, offline capabilities, and seamless cross-device performance.",
  },
];

// 8. Legacy Array Export for Backwards Compatibility
export const pwaTechStack = ["Next.js", "React", "Service Workers", "Workbox", "PWA Manifest", "Firebase"];
